import React, { useState } from 'react'
import { ChakraProvider, Box, Center, Text, Button } from '@chakra-ui/react'

const Contact = () => {
  const [loading, setLoading] = useState(false)
  function handleScroll() {
    const pageTop =
      document.documentElement.scrollTop || document.body.scrollTop
    const pageBottom = pageTop + window.innerHeight
    const fadeups = document.querySelectorAll('.fade_up')

    fadeups.forEach((fade_up) => {
      if (fade_up.getBoundingClientRect().top < pageBottom) {
        fade_up.classList.add('visible')
      } else {
        fade_up.classList.remove('visible')
      }
    })
  }

  document.addEventListener('scroll', handleScroll)

  return (
    <ChakraProvider>
      <Box
        w={{
          base: '90%',
          sm: '90%',
          md: '90%',
          lg: '90%',
          xl: '90%',
        }}
        alignContent='center'
        mx='auto'
        h={{
          base: 'auto',
          sm: 'auto',
          md: 'auto',
          lg: 'auto',
          xl: 'auto',
        }}>
        <Center>
          <Text
            fontSize={{
              base: '30px',
              sm: '30px',
              md: '35px',
              lg: '35px',
              xl: '35px',
            }}
            fontFamily='Inter'
            letterSpacing='5px'
            my='50px'>
            {' '}
            CONTACT ME
          </Text>
        </Center>
        <Center>
          <Text
            fontSize={{
              base: '15px',
              sm: '15px',
              md: '20px',
              lg: '20px',
              xl: '20px',
            }}
            fontFamily='Roboto Mono'
            letterSpacing='5px'
            mb='50px'
            mt={2}>
            {' '}
            You have an awesome idea you wish to pitch to me? Feel free to
            contact me. However, if you have other request or question, I'm
            still up for it. Check out my socials through my avatar at the top
            right of your screen or hit me up real quick on Gmail with the help
            of the button below.
          </Text>
        </Center>
        <Center>
          {' '}
          <Button
            className='slide_in'
            color='white'
            bg='olive'
            _hover={{ color: 'olive', bg: '#FAF0E6' }}
            variant='outline'
            onClick={() => setLoading(true)}
            isLoading={loading}
            loadingText='Submitting'
            size='lg'
            my={{
              base: 'auto',
              sm: 'auto',
              md: '20px',
              lg: '20px',
              xl: '20px',
            }}>
            <a href='mailto:cezerike@gmail.com'>
              <i className='fa-solid fa-envelope'></i> Gmail
            </a>
          </Button>
        </Center>
      </Box>
    </ChakraProvider>
  )
}

export default Contact
